export default "__VITE_ASSET__5c97dae5__"